import { defaultContact } from '../data/serviceCatalog';

export function buildMailtoHref(service, formData = {}, lang = 'es') {
  const target = service || defaultContact;
  const to = target.email || defaultContact.email;
  const title = target.title?.[lang] || target.title || 'Innovative Horizons';
  const subject = formData.subject && formData.subject.trim()
    ? formData.subject.trim()
    : lang === 'en'
      ? `Project inquiry - ${title}`
      : `Solicitud de información - ${title}`;

  const lines = lang === 'en'
    ? [
        `Hello ${target.contactName || 'team'},`,
        '',
        'I am sharing my details to request more information:',
        '',
        `Service of interest: ${title}`,
        `Name: ${formData.name || ''}`,
        `Email: ${formData.email || ''}`,
        `Phone: ${formData.phone || ''}`,
        `Company / institution: ${formData.company || ''}`,
        '',
        'Project details:',
        formData.message || '',
        '',
        'I look forward to your reply.'
      ]
    : [
        `Hola ${target.contactName || 'equipo'},`,
        '',
        'Comparto mis datos para solicitar más información:',
        '',
        `Servicio de interés: ${title}`,
        `Nombre: ${formData.name || ''}`,
        `Correo: ${formData.email || ''}`,
        `Teléfono: ${formData.phone || ''}`,
        `Empresa / institución: ${formData.company || ''}`,
        '',
        'Detalle del proyecto:',
        formData.message || '',
        '',
        'Quedo atento(a) a su respuesta.'
      ];

  const body = lines.join('\n');
  return `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
